var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-institution"},[_c('ed-layout-basic',[_c('div',{staticClass:"ed-institution__school bsx-mt-4"},[_c('ed-link',{staticClass:"bsx-mt-8"},[_vm._v("School Portal")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }